import { createReducer } from 'deox';
import { ServiceCategory } from '@/types';
import {
  fetchServiceCategoriesActions,
  fetchServiceCategoryByIdActions,
} from '@/redux/actions/service-directory/service-category';

export interface ServiceCategoryState {
  serviceCategories?: ServiceCategory[];
  serviceCategory?: ServiceCategory;
}

const initialState: ServiceCategoryState = {
  serviceCategories: undefined,
  serviceCategory: undefined,
};

const serviceDirectoryServiceCategoryReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchServiceCategoriesActions.success, (state, { payload }) => {
    return {
      ...state,
      serviceCategories: payload.data,
    };
  }),
  handleAction(fetchServiceCategoriesActions.reset, (state) => {
    return {
      ...state,
      serviceCategories: initialState.serviceCategories,
    };
  }),
  handleAction(fetchServiceCategoryByIdActions.success, (state, { payload }) => ({
    ...state,
    serviceCategory: payload,
  })),
]);

export default serviceDirectoryServiceCategoryReducer;
